export const getPhotosBaseUrl = (galleryType, urlPhotosphere, urlPhoto) => {
  switch (galleryType) {
    case 'photosphere':
      return urlPhotosphere;
    case 'photo':
      return urlPhoto;
    default:
      return null;
  }
};

export const notStartedPhotoSessionsURL = ({ includeProblem = false } = {}) =>
  `/mobile-api-ro/photographer/jobs?includeStarted=false&includeProblem=${includeProblem}`;
export const startedPhotoSessionsURL = () =>
  '/mobile-api-ro/photographer/pending-jobs?includeStarted=true';
export const startPhotoSessionURL = (photoSessionId) =>
  `/mobile-api/photographer/job/${photoSessionId}/start-session`;
export const photoSessionDetailURL = (photoSessionId) =>
  `/api/photo-sessions/${photoSessionId}`;
export const entryAccessEligibilityListURL = (houseId) =>
  `/mobile-api/house/${houseId}/photographer/entry-access/list`;
export const entryAccessURL = (houseId, journey) =>
  `/portfolio-manager-api/v1/photographer/${journey}/house/${houseId}/entry-access`;
export const firebaseAuthServiceURL = () => '/firebase/authenticate';
export const issueReportURL = (photoSessionId) =>
  `/mobile-api/photographer/job/${photoSessionId}/issue`;
export const getChecklistURL = () => '/api/v1/checklist-items';
export const finishChecklistSessionURL = (photoSessionId) =>
  `/api/v1/photo-sessions/${photoSessionId}/finish`;
export const getStepsProgressURL = () => '/api/v1/checklist/steps-progress';
export const publishPhotoSessionURL = () => '/api/v1/photo-sessions/publish';
export const getAuthorizationUrl = (userId, route) =>
  `/api/v1/users/${userId}/authorize/${route}`;
export const reportReasonsURL = () =>
  '/mobile-api-ro/photographer/report-reasons';
export const getQuarantinedCitiesURL = () => '/ownerapp-api/quarantined-cities';
// `agentUserId == null` (undefined or null) omits the `agent` filter, so the planner returns the
// region-wide availability instead of narrowing it down to a single photographer.
export const getScheduleDatesURL = (propertyId, agentUserId) => {
  const agentParam = agentUserId != null ? `&agent=${agentUserId}` : '';
  return `/planner/schedules/photo?properties=${propertyId}${agentParam}&attendanceType=IN_LOCO`;
};
export const rescheduleFixedSessionURL = (propertyId) =>
  `/api/v1/reschedule/${propertyId}/custom`;
export const rescheduleFlexibleSessionURL = (propertyId) =>
  `/api/v1/reschedule/${propertyId}/flexible`;
export const propertyUrl = (propertyId) =>
  `/mobile-api/property/${propertyId}/visitInfo`;
export const propertyAssessmentUrl = (photoSessionId) =>
  `/mobile-api/categories/assessments/job/${photoSessionId}`;
export const availablePhotoJobTypes = (propertyId) =>
  `/mobile-api/property/${propertyId}/available-photo-jobs-types`;
export const fetchPhotosURL = (propertyDomain, propertyId, galleryType) =>
  `/api/v1/${getPhotosBaseUrl(
    galleryType,
    `photospheres/${propertyDomain}`,
    'photos',
  )}/${propertyId}`;
export const deletePhotoURL = (photoId, galleryType, houseId) =>
  `/api/v1/${getPhotosBaseUrl(
    galleryType,
    'photospheres',
    `photos/${houseId}`,
  )}/${photoId}`;
export const updateMainPhotoURL = (id, houseId) =>
  `/api/v1/photos/${houseId}/${id}`;
export const rotatePhotoClockwiseURL = (propertyId, photoId, direction) =>
  `/api/v1/photos/${propertyId}/rotate/${photoId}/${direction}`;
export const photosphereCardImageUrl = () => process.env.DARKRUM_API_URL;
export const uploadFilePhotosphereURL = (
  houseType = 'HOUSE',
  houseId,
  galleryType,
) =>
  `${getPhotosBaseUrl(
    galleryType,
    `/kodak-api/api/v1/media/photospheres/${houseType}`,
    '/main-api/fotografo/uploadFoto',
  )}/${houseId}`;
export const updatePhotosphereURL = (galleryType, houseId) =>
  `/api/v1/${getPhotosBaseUrl(
    galleryType,
    'photospheres',
    `photos/${houseId}/update`,
  )}`;
export const deleteVideoLinkURL = (videoId) => `/api/v1/videos/${videoId}`;
export const uploadVideoLinkURL = () => '/api/v1/videos';
export const getVideoLinkURL = (houseType, houseId) =>
  `/api/v1/videos/${houseType}/${houseId}`;
export const userInfoURL = () => '/api/v1/user/me';
export const fetchGeneralConditionsURL = () =>
  '/api/v1/checklist/maintenance-conditions';
export const fetchRoomsSuggestionsURL = () => '/api/v1/suggestions/rooms';
export const listingRepresentativeURL = (houseId) =>
  `/portfolio-manager-api/v1/photographer/listing-representative/${houseId}`;
export const paymentListURL = () =>
  '/portfolio-manager-api/v1/photographer/payments/list?includeIssuanceDetails=true';
export const invoicePreSignURL = () =>
  '/portfolio-manager-api/v1/photographer/invoice/presign/upload';
export const commitInvoiceURL = () =>
  '/portfolio-manager-api/v1/photographer/invoice/commit';
